import React from 'react';

import { AudioTrack, Player } from '../../types';
import cleanAudioTrackText from '@smart-tv/utils/formatter/clean-track-text';
import { storePersistentData } from '@smart-tv/utils/persistent-data/persistent-data';

interface Props {
  open: boolean;
  onClose: () => void;
  audioTracks?: AudioTrack[];
  selectedAudioTrack?: AudioTrack;
  setSelectedAudioTrack: (audioTrack: AudioTrack | undefined) => void;
  player?: Player;
}

const usePlayerAudioDialog = (props: Props) => {
  const { onClose, audioTracks, setSelectedAudioTrack, player } = props;

  const handleImmediateReload = React.useCallback(() => {
    const position = player?.getPosition();
    player?.setPosition(position ? Math.abs(position - 0.1) : 0);
  }, [player]);

  const handleSelectAudioTrack = React.useCallback(
    (id: string) => {
      setSelectedAudioTrack(
        audioTracks?.find(
          (audioTrack) => cleanAudioTrackText(audioTrack.id) === cleanAudioTrackText(id)
        )
      );
      player?.selectAudioTrack(cleanAudioTrackText(id));
      storePersistentData(
        'audio-track',
        audioTracks?.find(
          (audioTrack) => cleanAudioTrackText(audioTrack.id) === cleanAudioTrackText(id)
        ),
        false
      );
      handleImmediateReload();
      onClose();
    },
    [onClose, setSelectedAudioTrack, audioTracks, player, handleImmediateReload]
  );

  return {
    handleSelectAudioTrack
  };
};

export default usePlayerAudioDialog;
